import { render, staticRenderFns } from "./CurriculumDialog.vue?vue&type=template&id=560ce294&"
import script from "@/views/Curricula/CurriculumDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Curricula/CurriculumDialog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports